<mat-form-field appearance="outline">
  <mat-label>{{ field.key | translate }}</mat-label>
  <input matInput
         #timePicker
         id="timePicker"
         type="time"
         step="1"
         (input)="onValueChange()"
         [formControl]="field.control"
         [transform]="toDbModel.bind(this)"
         placeholder="{{ field.key | translate }}" />
</mat-form-field>
